import store from '../store';

export const getProgramIdFromStore = () => {
  const state = store.getState();
  return state?.app?.config?.programId;
};
